import React, { createContext, useContext, useState } from 'react';
import { prodEcomTypeOptions, PROD_ECOM_TYPE } from '../constant/constant';

const EcomTypeContext = createContext();

export const EcomTypeProvider = ({ children }) => {
    const [prodEcomType, setProdEcomType] = useState(() => {
        const stored = localStorage.getItem('prodEcomType');
        if (stored && prodEcomTypeOptions.some(o => o.value === stored)) return stored;
        return prodEcomTypeOptions[0].value;
    });

    const toggleEcomType = () => {
        setProdEcomType(prev => {
            const next = prev === PROD_ECOM_TYPE.ESSENTIAL ? PROD_ECOM_TYPE.LIFESTYLE : PROD_ECOM_TYPE.ESSENTIAL;
            localStorage.setItem('prodEcomType', next);
            return next;
        });
    };

    const setEcomType = (value) => {
        if (prodEcomTypeOptions.some(o => o.value === value)) {
            setProdEcomType(value);
            localStorage.setItem('prodEcomType', value);
        }
    };

    return (
        <EcomTypeContext.Provider value={{ prodEcomType, toggleEcomType, setEcomType }}>
            {children}
        </EcomTypeContext.Provider>
    );
};

export const useEcomType = () => useContext(EcomTypeContext);
